/**
 * Displays single product card
 * Note: Styles and add to cart/quickview functionality borrowed from the BigCommerce 2dsemiconductors theme
 * Child component of ProductGrid
 */
import React from "react";
import styled from "styled-components";
import NumberFormat from "react-number-format";

const ProductCard = (props) => {
  const {
    custom_url,
    product_id,
    image,
    image_alt,
    is_featured,
    name,
    price,
    date_created,
  } = props.product;

  return (
    <Card 
			className="product-item search-item" 
			data-product-item="" 
			data-is-featured={is_featured} 
			data-product-date={new Date(date_created).toLocaleString()}
		>
      <div className="product-item-image search-item-image aspect-one-by-one">
        <a
          href={custom_url}
          title={name}
          style={{ backgroundImage: `url(${image})` }}
        >
          <img src={image} alt={image_alt} />
        </a>
      </div>
      <div className="product-item-details">
        <h1 className="product-item-title search-item-title ">
          <a href={custom_url}>{name}</a>
        </h1>
        <div className="product-item-price search-item-price">
          <div className="price">
            <div
              className="price-withouttax"
              data-product-price-wrapper="without-tax"
            >
              <div className="price-value-wrapper">
                <label className="price-label"></label>
                <span className="price-value" data-product-price="">
                  <span>
                    <NumberFormat
                      value={price}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"$"}
                      decimalScale={2}
											fixedDecimalScale={true}
                    />
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="buttons">
          <a
            href={`/cart.php?action=add&product_id=${product_id}`}
            className="button button-primary button-cart-action"
          >
            Add To Cart
          </a>
          <button
            className="button button-secondary button-quick-view"
            data-quick-view=""
            data-product-id={product_id}
          >
            Quick Look
          </button>
        </div>
      </div>
    </Card>
  );
};

export default ProductCard;

const Card = styled.article`
  margin-bottom: 5rem;
  &:hover .product-item-details {
    bottom: 6.25rem;
  }
`;